import React, { useState, useEffect } from 'react';

const quests = [
    { id: 1, question: "What is HTML and What is the use of HTML?" },
    { id: 2, question: "What are the few Compulsory tags in HTML?" },
    { id: 3, question: "What all tags do we write in the <head></head> tag?" },
    { id: 4, question: "List a few Self-Closing Tags in HTML?" },
    { id: 5, question: "Why do we use Class and Id in HTML?" },
    { id: 6, question: "What is the meaning of Markup Language?" },
    { id: 7, question: "Why do we use CSS in any webpage?" },
    { id: 8, question: "What is the role of CSS in Web Technology?" },
    { id: 9, question: "In how many ways can we write CSS for a single HTML file?" },
    { id: 10, question: "What is the Precedence Order of CSS?" },
    { id: 11, question: "Where do we write Internal and Inline CSS in the HTML file?" },
    { id: 12, question: "What are Pseudo Classes and Pseudo Elements in CSS?" },
    { id: 13, question: "Difference between Pseudo Classes and Pseudo Elements?" },
    { id: 14, question: "What is the role of JavaScript in Web Technology?" },
    { id: 15, question: "In How many ways can we write JavaScript?" },
    { id: 16, question: "Why do we get an Error if we write the <script></script> tag in between the body part and not at the end?" },
    { id: 17, question: "What are the different data types present in JavaScript?" },
    { id: 18, question: "Difference between var and let keyword in JavaScript." },
    { id: 19, question: "What is DOM?" },
    { id: 20, question: "How would you manipulate the DOM using JavaScript?" },
    { id: 21, question: "How do you select individual elements in DOM using JavaScript?" },
];

export default function PartOne() {

    const loadCheckedState = () => {
        const storedState = localStorage.getItem('checkedState');
        return storedState ? JSON.parse(storedState) : {};
    };

    const [checkedState, setCheckedState] = useState(loadCheckedState);


    const saveCheckedState = () => {
        localStorage.setItem('checkedState', JSON.stringify(checkedState));
    };


    const handleCheckboxClick = (id) => {
        setCheckedState((prevState) => {
            const newState = { ...prevState, [id]: !prevState[id] };
            saveCheckedState();
            return newState;
        });
    };

    useEffect(() => {

        saveCheckedState();
    }, [checkedState]);

    return (
        <section id='partOne' className="text-gray-600 body-font">
            <div className="container px-5 py-24 mx-auto">
                <div className="flex flex-col text-center w-full mb-20">
                    <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-red-600">Part 1</h1>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base">Questions Based on HTML, CSS & JS/JS DOM</p>
                </div>
                <div className="flex flex-wrap -m-2">
                    {quests.map((question) => (
                        <div key={question.id} className="p-2 lg:w-1/3 md:w-1/2 w-full">
                            <div className={`h-full flex items-center border-red-600 border-2 bg-gray-100 p-4 rounded-lg ${checkedState[question.id] ? 'bg-green-100' : ''}`}>

                                <div className="flex-grow">
                                    <div className='flex gap-2 items-center'>
                                        <h2 className="text-gray-900 title-font font-medium">Question {question.id}</h2>
                                        <input
                                            type="checkbox"
                                            checked={checkedState[question.id]}
                                            onChange={() => handleCheckboxClick(question.id)}
                                            className="mr-2"
                                        />
                                    </div>
                                    <p className="text-gray-800">{question.question}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}